import React, { ChangeEvent } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import _ from 'lodash';
import {
  MobileDesignConfigClasses,
  MobileDesignConfigState,
  MobileDesignSection,
  MobileDesignProduct
} from '../MobileDesignConfig.types';
import { Checkbox, SearchBar, Spinner } from '../..';
import { UNIT } from '../../../constants';

const searchStyle = {
  border: '1px solid #E2E2E2',
  borderRadius: UNIT * 1.5,
  height: UNIT * 2.8125,
  marginBottom: UNIT * 0.5625
};

interface ProductSectionProps {
  classes: MobileDesignConfigClasses;
  state: MobileDesignConfigState;
  sections: MobileDesignSection[];
  searchTerm: string;
  onSearchChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onApplySearch: (term: string) => void;
  onProductCheck: (product: MobileDesignProduct) => void;
}

const ProductListSection = ({ classes, state, sections, onProductCheck }: { classes: MobileDesignConfigClasses, state: MobileDesignConfigState, sections: MobileDesignSection[], onProductCheck: (product: MobileDesignProduct) => void }) =>
  _.map(sections, section => (
    <li key={section.key}>
      <ListSubheader className={classes.listHeaderStyle}>{section?.name?.toUpperCase()}</ListSubheader>
      {_.map(section.products, item => (
        <ListItem key={item.key}>
          <Checkbox
            value={Object.values(state.products).some(product => product.key === item.key)}
            onClick={() => onProductCheck(item)}
            text={item.name}
            className={classes.textStyle}
          />
        </ListItem>
      ))}
    </li>
  ));

export const ProductSection = ({ classes, state, sections, searchTerm, onSearchChange, onApplySearch, onProductCheck }: ProductSectionProps) => {
  return (
    <>
      <SearchBar
        value={searchTerm}
        label="Chercher un produit..."
        onChange={onSearchChange}
        onBlur={() => onApplySearch(searchTerm)}
        onClick={() => onApplySearch(searchTerm)}
        style={searchStyle}
      />
      {state.isLoadingProducts ? (
        <div className={classes.loadingProduct}>
          <Spinner />
        </div>
      ) : (
        <List className={classes.root} subheader={<li />}>
          <ProductListSection classes={classes} state={state} sections={sections} onProductCheck={onProductCheck} />
        </List>
      )}
    </>
  );
};

